import { Settinglable } from "../models/setting"
import { API_PREFIX } from "./constant";
import { Request } from "./request";

export function getRegistrationConfigSubmit(body: any): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/registrationConfig/submit`,
    method: 'POST',
    body,
  }
}


export function geRegistrationConfigList(params: any): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/registrationConfig/page`,
    method: 'GET',
    params,
  }
}

export function getRegistrationConfigDetail(): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/registrationConfig/detail`,
    method: 'GET',
  }
}